import { SERVER_URL } from '../../constants';
import {
  fetchGetAuth,
  fetchPostAuth
} from '../../util/FetchUtil';

const controller = 'usuario-cartao-credito';

export const findUsuarioCartaoCreditoByCurrentUser = () => {
  const url = SERVER_URL + controller + "/query-list";
  return fetchGetAuth(url);
}

export const criarUsuarioCartaoCredito = (criaTokenCartaoCredito) => {
  const url = SERVER_URL + controller + "/create";
  return fetchPostAuth(url, criaTokenCartaoCredito);
}